// Angular
import { Injectable, OnDestroy, inject } from '@angular/core';
// Material
import { MatPaginatorIntl } from '@angular/material/paginator';
// Transloco
import { TranslocoService } from '@jsverse/transloco';
// RxJS
import { Subject, takeUntil, combineLatest } from 'rxjs';

@Injectable()
export class MatPaginatorI18nService extends MatPaginatorIntl implements OnDestroy {

    private readonly translocoService = inject(TranslocoService);
    private readonly unsubscribe = new Subject<void>();

    constructor() {
        super();

        combineLatest({
            itemsPerPage: this.translocoService.selectTranslate('label_items_per_page'),
            firstPage: this.translocoService.selectTranslate('label_first_page'),
            lastPage: this.translocoService.selectTranslate('label_last_page'),
            nextPage: this.translocoService.selectTranslate('label_next_page'),
            previousPage: this.translocoService.selectTranslate('label_previous_page')
        }).pipe(
            takeUntil(this.unsubscribe)
        ).subscribe(labels => {
            this.itemsPerPageLabel = labels.itemsPerPage;
            this.firstPageLabel = labels.firstPage;
            this.lastPageLabel = labels.lastPage;
            this.nextPageLabel = labels.nextPage;
            this.previousPageLabel = labels.previousPage;
            this.changes.next();
        });
    }

    /**
     * On Destroy
     * @memberof MatPaginatorI18nService
     */
    ngOnDestroy(): void {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }
}